import { useEffect, useRef } from 'react'

export const useInterval = (callback, delay) => {
  const callbackRef = useRef()

  useEffect(() => {
    callbackRef.current = callback
  }, [callback])

  useEffect(() => {
    const tick = () => {
      if (callbackRef.current) {
        callbackRef.current()
      }
    }
    if (delay !== null) {
      const id = setInterval(tick, delay)
      return () => clearInterval(id)
    }
  }, [delay])
}
